<template lang="pug">
    v-stepper.elevation-1( v-model="step" )
        v-stepper-header( class="elevation-0" dense )
            v-stepper-step( :complete="complete.basic" step="1" ) Información general
            v-divider
            v-stepper-step( :complete="complete.affiliation" step="2" ) Prevision y salud
            v-divider
        v-stepper-items
            v-stepper-content( class="elevation-0" step="1" )
                crud-form( v-bind="formProps" @calculate="calculateBasicForm" @submitForm="submitBasicForm" )
            v-stepper-content( class="elevation-0" step="2" )
                crud-form( v-bind="formPropsPrev" @calculate="calculatePrevision" @submitForm="submitAffiliationForm")
        v-container( fluid )
            v-btn( dark large @click="step = 1" v-if="step === 2"  )
                v-icon navigate_before
                | anterior
            v-btn( color="primary" :disabled="!complete.basic" large @click="goToStepTwo" v-if="step === 1" ) siguiente
                v-icon navigate_next
            v-btn( color="primary" :disabled="!complete.basic" large @click="submitStepper" v-if="step === 2") crear
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
import { CrudForm } from '@/components/reusable_components'
import { FormToolbar } from '@/components/toolbars'
import EmployeeService from '@/services/api/employee'
//
import HealthAffiliationService from '@/services/api/healthAffiliation'
import PrevisionService from '@/services/api/prevision'
import IsapreTypeService from '@/services/api/isapreType'
//
import { EmployeeFields, EmployeeHealthFields } from './fields'
import { EmployeesListHeaders } from './headers'
//
export default {
    components: {
        'crud-form': CrudForm,
        'v-toolbar-form': FormToolbar,
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        formProps() {
            return {
                class: 'elevation-0',
                fields: EmployeeFields,
                noButtons: true,
                ref: 'basicForm',
            }
        },

        /**
         *
         */
        formPropsPrev() {
            return {
                class: 'elevation-0',
                fields: this.formDataPrev,
                noButtons: true,
                ref: 'refPrevisionForm',
            }
        },
    },
    data() {
        return {
            complete: {
                affiliation: false,
                basic: false,
            },
            formDataPrev: EmployeeHealthFields,
            items: [
                {
                    text: 'Finanzas',
                    exact: true,
                    to: '/',
                },
                {
                    text: 'Empleados',
                    exact: true,
                    to: '/employees',
                },
                {
                    text: 'Crear empleado',
                    exact: true,
                    to: '/employees/new',
                },
            ],
            originalFields: EmployeeHealthFields,
            step: 1,
        }
    },
    methods: {
        /**
         *
         */

        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */

        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        setFieldOptionsData(index, data) {
            this.formDataPrev[index].options.data = data
        },

        //-
        calculatePrevision: function(event) {
            //-
            switch (event.field) {
                case 'hr_health_affiliation_id':
                    switch (event.value) {
                        case 1:
                            //- Fonasa
                            this.hide(1)
                            break
                        case 2:
                            //- Isapre
                            this.hide(2)
                            break
                    }
                    break
                case 'hr_prevision_id':
                    this.formDataPrev[0].value = this.$refs.refPrevisionForm.vmodels.hr_prevision_id
                    break
            }
            this.complete.affilation = this.$refs.refPrevisionForm.$refs.form.validate()
        },
        //-
        hide: function(affiliation) {
            //-
            if (affiliation === 1) {
                let newFonasaFields = this.originalFields.filter(
                    item =>
                        item.field === 'hr_prevision_id' ||
                        item.field === 'hr_health_affiliation_id'
                )
                this.formDataPrev = newFonasaFields
            } else {
                this.formDataPrev = this.originalFields
            }
            this.formDataPrev[0].value = this.$refs.refPrevisionForm.vmodels.hr_prevision_id
            this.formDataPrev[1].value = this.$refs.refPrevisionForm.vmodels.hr_health_affiliation_id
        },
        /**
         *
         */
        calculateBasicForm() {
            // console.log('event basic: ', event)
            this.complete.basic = this.$refs.basicForm.$refs.form.validate()
        },

        /**
         *
         */
        reset: async function() {
            this.setTitleTopBar('Crear empleado')
        },

        /**
         *
         */
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        //-
        setFieldValue: function(index, value) {
            this.formDataPrev[index].value = value
        },
        //-
        resetFormPrev: function() {
            //
            this.setFieldValue(0, '')
            this.setFieldValue(1, '')
            this.setFieldValue(2, '')
            this.setFieldValue(3, '')
            //
            this.formDataPrev = [...this.formDataPrev]
        },

        /**
         *
         */
        submitBasicForm(event) {
            this.complete.basic = true
        },
        submitAffiliationForm(event) {
            this.complete.affiliation = true
        },
        goToStepTwo: async function() {
            //- Servicio para consultar si Rut ingresado ya existe en los registros, mensaje de error en Rut!
            const response = await EmployeeService.fetchByRut(
                this.$refs.basicForm.vmodels.rut
            )
            if (response.length === 0) {
                this.step = 2
            } else {
                this.showSnackbar(
                    'error',
                    'RUT ya se encuentra registrado',
                    response.error || response.message
                )
            }
        },
        /**
         *
         */
        async submitStepper() {
            //
            this.resetSnackbarState()
            //-
            let dataEmployee = {}
            dataEmployee.rut = this.$refs.basicForm.vmodels.rut
            dataEmployee.names = this.$refs.basicForm.vmodels.names
            dataEmployee.last_name1 = this.$refs.basicForm.vmodels.last_name1
            dataEmployee.last_name2 = this.$refs.basicForm.vmodels.last_name2
            dataEmployee.email = this.$refs.basicForm.vmodels.email
            //
            if (
                this.$refs.refPrevisionForm.vmodels.hr_prevision_id !== '' &&
                this.$refs.refPrevisionForm.vmodels.hr_health_affiliation_id !==
                    ''
            ) {
                //-
                dataEmployee.hr_prevision_id = this.$refs.refPrevisionForm.vmodels.hr_prevision_id
                if (
                    this.$refs.refPrevisionForm.vmodels
                        .hr_health_affiliation_id === 1
                ) {
                    dataEmployee.hr_health_affiliation_id = 1
                    //-
                    const response = await EmployeeService.create(dataEmployee)
                    this.getResponse(response)
                } else if (
                    this.$refs.refPrevisionForm.vmodels
                        .hr_health_affiliation_id === 2
                ) {
                    if (
                        this.$refs.refPrevisionForm.vmodels
                            .hr_isapre_type_id !== '' &&
                        this.$refs.refPrevisionForm.vmodels.uf_amount !== '' &&
                        this.$refs.refPrevisionForm.vmodels.uf_amount > 0
                    ) {
                        dataEmployee.hr_health_affiliation_id = 2
                        dataEmployee.hr_isapre_type_id = this.$refs.refPrevisionForm.vmodels.hr_isapre_type_id
                        dataEmployee.amount = this.$refs.refPrevisionForm.vmodels.uf_amount
                        dataEmployee.hr_previred_currency_id = this.$refs.refPrevisionForm.vmodels.hr_previred_currency_id
                        dataEmployee.contract_number = this.$refs.refPrevisionForm.vmodels.contract_number
                        //-
                        const response = await EmployeeService.create(
                            dataEmployee
                        )
                        this.getResponse(response)
                    } else {
                        this.showSnackbar(
                            'warning',
                            'Ingrese datos faltantes de Isapre',
                            response.error || response.message
                        )
                    }
                }
            } else {
                this.showSnackbar(
                    'warning',
                    'Ingrese datos faltantes',
                    response.error || response.message
                )
            }
        },
        getResponse: function(response) {
            switch (response.status) {
                case 'error':
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.error || response.message
                    )
                    break
                case 'success':
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Empleado creado con éxito.'
                    )
                    this.$router.push({ name: 'employee-list' })
                    this.resetFormPrev()
                    break
                default:
                    break
            }
        },
    },
    mounted() {
        this.reset()
    },
    beforeMount: async function() {
        this.setFieldOptionsData(0, await PrevisionService.fetchAll())
        this.setFieldOptionsData(1, await HealthAffiliationService.fetchAll())
        this.setFieldOptionsData(2, await IsapreTypeService.fetchAll())
    },
    watch: {
        /**
         *
         */
        $route() {
            this.reset()
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('CREATE_EMPLOYEE')) ctx.$router.push('/')
        })
    },
}
</script>

<style>
.v-tabs__bar {
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    margin-bottom: -2px;
    z-index: 1;
}
</style>
